import { useCallback, useMemo } from 'react';
import { WarehouseGSLAEntry } from '../types/bulkGslaTypes';

interface ColumnDefinition {
    label: string;
    property: string;
    formatter?: (rowIndex: number, rowData: any) => { element: any };
}

export const useGSLAColumns = (productionCapabilitySet: Set<string>) => {
    const pcFormatter = useCallback((rowIndex: number, rowData: WarehouseGSLAEntry, pc: string) => {
        const pcEntry = rowData[pc] as {
            actualGSLAInSeconds?: number;
            recommendedGSLAInSeconds?: number;
        };

        let element = document.createElement('div');
        element.style.display = 'flex';
        element.style.flexDirection = 'column';

        const actualValue = pcEntry?.actualGSLAInSeconds?.toString() ?? '';
        const recommendedValue = pcEntry?.recommendedGSLAInSeconds
            ? `(${pcEntry.recommendedGSLAInSeconds})`
            : '';

        element.innerHTML = `
            <div>${actualValue}</div>
            <div>${recommendedValue}</div>`;

        if (pcEntry?.actualGSLAInSeconds! > pcEntry?.recommendedGSLAInSeconds!) {
            element.className = 'lowerRecommended';
        }
        if (pcEntry?.actualGSLAInSeconds! < pcEntry?.recommendedGSLAInSeconds!) {
            element.className = 'higherRecommended';
        }

        return { element: element };
    }, []);

    const constructColumns = useCallback((productionCapabilitySet: Set<string>): ColumnDefinition[] => {
        const columns: ColumnDefinition[] = [
            {
                label: 'Warehouse ID',
                property: 'warehouseId',
            },
        ];

        productionCapabilitySet.forEach(pc => {
            columns.push({
                label: pc,
                property: pc,
                formatter: (rowIndex: number, rowData: any) =>
                    pcFormatter(rowIndex, rowData, pc),
            });
        });

        return columns;
    }, [pcFormatter]);

    const columns = useMemo(() => {
        return productionCapabilitySet.size !== 0
            ? constructColumns(productionCapabilitySet)
            : [];
    }, [productionCapabilitySet, constructColumns]);

    return { columns };
};